import {
    Box,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Grid,
    Link,
    Tab,
    Tabs,
    Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import BaseButton from "../ui/BaseButton";
import { useState } from "react";
import userService from "../../services/user";
import { useDispatch } from "react-redux";
import { addUserTerms } from "../../redux/userSlice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 0,
        padding: "5px",
    },
    "& .MuiDialogTitle-root": {
        fontSize: 20,
        fontWeight: 600,
    },
    "& .MuiDialogContent-root": {
        paddingBottom: theme.spacing(1),
    },
    "& .MuiDialogActions-root": {
        // padding: theme.spacing(2),
        justifyContent: "space-between",
    },
}));

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            sx={{ bgcolor: "V003", padding: "3px 25px 3px 0px", overflow: "auto" }}
            {...other}
        >
            {value === index && children}
        </Box>
    );
}

export default function TermsModal(props) {
    const { open, setOpen, userDetails, setAlertType, setTexto, setShow, setIsLoading } = props;

    const [t] = useTranslation("global");
    const [termsCheckbox, setTermsCheckbox] = useState(false);
    const [personalCheck, setPersonalCheck] = useState(false);
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        event.preventDefault();
        setValue(newValue);
    };

    const dispatch = useDispatch();

    const handleClose = (event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setOpen(false);
        }
    };

    const handleChangeTerms = (event) => setTermsCheckbox(event.target.checked);

    const handleChangePersonal = (event) => setPersonalCheck(event.target.checked);

    const acceptTerms = async () => {
        setIsLoading(true);
        await userService
            .acceptTerms({
                term_id: userDetails?.latest_terms?._id,
                data_sharing: personalCheck,
            })
            .then(async () => {
                dispatch(addUserTerms(true));
                handleClose();
                setAlertType("success");
                setTexto(t("register.saveSuccessfully"));
                setShow(true);
            })
            .catch((error) => {
                console.log(error.response);
                setAlertType("error");
                setTexto(t("register.error"));
                setShow(true);
            });
        setIsLoading(false);
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }

    return (
        <BootstrapDialog open={open} onClose={handleClose} fullScreen disableEscapeKeyDown>
            <DialogTitle>{t("terms.uptTnC")}</DialogTitle>
            <DialogContent>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs value={value} onChange={handleChange}>
                        <Tab label="Terms & Conditions" {...a11yProps(0)} />
                        <Tab label="Privacy policy" {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <Box
                        dangerouslySetInnerHTML={{
                            __html: userDetails.latest_terms.terms_content,
                        }}
                        fontSize={12}
                        lineHeight="normal"
                        sx={{ textAlign: "justify" }}
                    ></Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <Box
                        dangerouslySetInnerHTML={{
                            __html: userDetails.latest_terms.privacy_content,
                        }}
                        fontSize={12}
                        lineHeight="normal"
                        sx={{ textAlign: "justify", paddingTop: 1.5 }}
                    ></Box>
                    <FormControlLabel
                        control={<Checkbox checked={personalCheck} onChange={handleChangePersonal} size="small" />}
                        label={<Typography fontSize={12}>{t("terms.dontSell")}</Typography>}
                        sx={{ marginLeft: 6 }}
                    />
                    <Box
                        dangerouslySetInnerHTML={{
                            __html: userDetails.latest_terms.privacy_optional_content,
                        }}
                        fontSize={12}
                        lineHeight="normal"
                        sx={{ textAlign: "justify" }}
                    ></Box>
                </CustomTabPanel>
            </DialogContent>
            <DialogActions sx={{ display: "block", padding: "0px 30px 15px 24px" }}>
                <Grid container sx={{ display: "block" }}>
                    <Grid item>
                        <FormControlLabel
                            control={<Checkbox checked={termsCheckbox} onChange={handleChangeTerms} size="small" />}
                            label={
                                <Typography fontSize={12}>
                                    {t("terms.msg1")}{" "}
                                    <Link
                                        sx={{ fontWeight: 700, textDecoration: "none" }}
                                        onClick={(e) => handleChange(e, 0)}
                                        color="secondary"
                                    >
                                        Terms and Conditions of Service
                                    </Link>
                                    {` ${t("terms.and")} `}
                                    <Link
                                        sx={{ fontWeight: 700, textDecoration: "none" }}
                                        onClick={(e) => handleChange(e, 1)}
                                        color="secondary"
                                    >
                                        Privacy Policy
                                    </Link>
                                </Typography>
                            }
                        />
                    </Grid>
                </Grid>
                <Grid container justifyContent="end" mt={1.5}>
                    <Grid item>
                        <BaseButton disableElevation onClick={acceptTerms} sizebutton="l" disabled={!termsCheckbox}>
                            Continue
                        </BaseButton>
                    </Grid>
                </Grid>
            </DialogActions>
        </BootstrapDialog>
    );
}
